import { Slot } from 'one'

export default function Layout() {
  return <Slot />
}
